import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=533d87be&scoped=true&"
import script from "./LogoutDialog.vue?vue&type=script&lang=js&"
export * from "./LogoutDialog.vue?vue&type=script&lang=js&"
import style0 from "./LogoutDialog.vue?vue&type=style&index=0&id=533d87be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d87be",
  null
  
)

export default component.exports